import { put, takeLatest, all, call } from "redux-saga/effects";
import {
  getResourceData,
  signOutUser,
  getLoginDeatails,
  getAuthTokenDetails,
  localUserLogin,
  getIdpAuthTokenApi,
  fetchLocalUserAccessToken,
  localUserSignup,
  localUserForgotPassword,
  localUserResetPassword,
} from "../api";
import { loginActions } from "../../constants/loginActionTypes";
import {
  loginSetData,
  loginSetError,
  logoutSuccess,
  logoutFailed,
  getLoginDetailsSuccess,
  setLoginDetailsError,
  loginUserSuccess,
  getAuthTokenSuccess,
  getAuthTokenFailed,
  setInvalidTenantUrl,
  setLocalUserTokens,
  setLocalUserLoginError,
  setIdpToken,
  veriFiedLocalUser,
  invalidLocalUser,
  setInvalidWorkspaceUser,
  setVerifiedWorkspaceUser,
  localWorkspaceLoginSuccess,
  localWorkspaceLoginError,
  setLocalUserSignupSuccess,
  setLocalUserSignupError,
  setLocalUserForgotPasswordError,
  setLocalUserForgotPasswordSuccess,
  setLocalUserResetPasswordSuccess,
  setLocalUserResetPasswordError,
} from "../actions/loginActions";
import { statusCode } from "../../constants/apis/apiStatus";
import { toasterFlags } from "../../constants/componentConstants";
import { toastNotification } from "../../utils/toast";
import { directLoginStorage, localStorageHelper } from "../../utils/storageHelper";
import {
  storageCleanUpFunction,
  setIdpTokenDataInLocalStorage,
  storageCleanUpFunctionForWorkspace,
  getErrorMsg,
} from "../../utils/genericUtils";
import { getInvitationApi } from "../api/workspaceManager";

export function* getAllowedResource() {
  try {
    const data = yield call(getResourceData);
    yield put(loginSetData(data));
  } catch (err) {
    yield put(loginSetError(err));
  }
}

export function* signOut({ payload }) {
  try {
    const logoutData = yield call(signOutUser, payload);
    if (logoutData.status === statusCode.Ok200) {
      yield put(logoutSuccess(logoutData));
      let toSetPortalValue = false;
      if (localStorageHelper.get("portalWalkthrough")) toSetPortalValue = true;
      localStorageHelper.clear();
      sessionStorage.clear();
      directLoginStorage.clear();
      if (toSetPortalValue) localStorageHelper.set("portalWalkthrough", "true");
      window.open(logoutData?.data?.success?.auth_url, "_self");
    } else {
      yield put(logoutFailed(logoutData));
    }
  } catch (err) {
    console.log(err);
  }
}

export function* loginDetails({ payload }) {
  try {
    const loginDetail = yield call(getLoginDeatails, payload);
    if (loginDetail?.status === statusCode.Ok200) {
      yield put(
        getLoginDetailsSuccess({
          data: loginDetail?.data?.success,
          status: loginDetail?.status,
        })
      );
    } else {
      const errorData = loginDetail?.response;
      yield put(setInvalidTenantUrl({ status: errorData?.status, data: errorData?.data }));
      toastNotification("error", errorData?.data?.message);
      localStorageHelper.clear();
      sessionStorage.clear();
    }
  } catch (err) {
    console.log(err);
  }
}

//Login Function for AAD Login
export function* loginFunction({ payload }) {
  try {
    const userLoggedIn = yield call(getLoginDeatails, payload);
    if (userLoggedIn?.status === statusCode.Ok200) {
      if (userLoggedIn?.data?.success) {
        yield put(loginUserSuccess({ data: userLoggedIn?.data?.success, status: userLoggedIn?.status }));
      }
    } else {
      toastNotification(toasterFlags.WARN, userLoggedIn?.response?.data?.message);
      yield put(setLoginDetailsError(userLoggedIn?.response));
    }
  } catch (err) {
    console.log(err);
  }
}

//get token for AAD login
export function* authTokenFunction({ payload }) {
  try {
    const tokenData = yield call(getAuthTokenDetails, payload);
    if (tokenData?.status === statusCode.Ok200) {
      if (tokenData?.data?.success) {
        yield put(getAuthTokenSuccess({ data: tokenData?.data?.success, status: tokenData?.status }));
      }
    } else {
      const errorData = tokenData?.response?.data;
      yield put(getAuthTokenFailed(errorData));
      toastNotification("error", errorData?.message);
      localStorageHelper.clear();
      sessionStorage.clear();
      if (errorData?.action === loginActions.REDIRECT) {
        window.open(errorData?.auth_url, "_self");
      }
    }
  } catch (err) {
    console.log(err);
  }
}

export function* localUserSignupFunction({ payload }) {
  try {
    const data = yield call(localUserSignup, payload);
    if (data?.status === statusCode.Ok200) {
      toastNotification(toasterFlags.SUCCESS, data?.data?.message);
      yield put(setLocalUserSignupSuccess(data));
    } else {
      const errorData = data?.response;
      yield put(setLocalUserSignupError(errorData));
      if (errorData?.data?.message?.email) {
        toastNotification(toasterFlags.WARN, errorData?.data?.message?.email?.[0]);
      } else {
        toastNotification(toasterFlags.WARN, errorData?.data?.message);
      }
    }
  } catch (err) {
    toastNotification("error", "Something went wrong...!");
  }
}

export function* localUserLoginFunction({ payload }) {
  try {
    //Api call to fetch token from idp
    const localUserTokenData = yield call(fetchLocalUserAccessToken, payload);
    if (localUserTokenData?.status === statusCode.Ok200 && localUserTokenData?.data?.accessToken) {
      let payload = {
        tenant_id: localStorageHelper.get("localTenantId"),
        token: localUserTokenData?.data?.accessToken,
      };
      //Api call to verify token and fetch user details
      const verifiedToken = yield call(getIdpAuthTokenApi, payload);
      if (verifiedToken?.status === statusCode.Ok200 && verifiedToken?.data) {
        let tokenData = {
          ...verifiedToken?.data?.success,
          accessToken: localUserTokenData?.data?.accessToken,
        };
        yield put(setLocalUserTokens({ data: tokenData, status: verifiedToken?.status }));
      } else {
        const errorData = verifiedToken?.response;
        toastNotification("error", errorData?.message);
        yield put(setLocalUserLoginError({ data: errorData?.data, status: errorData?.status }));
        localStorageHelper.clear();
        sessionStorage.clear();
      }
    } else {
      if (localUserTokenData?.data) {
        // block for error handling from IDP token generation
        const errorData = localUserTokenData?.data;
        const errorMsg = getErrorMsg(errorData?.errorMessage);
        toastNotification("error", errorMsg);
        storageCleanUpFunction();
      } else {
        // block for error handling from API token generation
        const errorData = localUserTokenData?.response?.data;
        toastNotification("error", errorData?.message);
        storageCleanUpFunction();
      }
    }
  } catch (err) {
    toastNotification("error", "Something went wrong...!");
  }
}

export function* localUserForgotPasswordFunction({ payload }) {
  try {
    const data = yield call(localUserForgotPassword, payload);
    if (data?.status === statusCode.Ok200) {
      toastNotification(toasterFlags.SUCCESS, data?.data?.message);
      localStorageHelper.set("resetUrl", data?.data?.reset_url);
      yield put(setLocalUserForgotPasswordSuccess(data));
    } else {
      const errorData = data?.response;
      yield put(setLocalUserForgotPasswordError(errorData));
      if (errorData?.data?.message?.email) {
        toastNotification(toasterFlags.WARN, errorData?.data?.message?.email?.[0]);
      } else {
        toastNotification(toasterFlags.WARN, errorData?.data?.message);
      }
    }
  } catch (err) {
    toastNotification("error", "Something went wrong...!");
  }
}

export function* localUserResetPasswordFunction({ payload }) {
  try {
    const data = yield call(localUserResetPassword, payload);
    if (data?.status === statusCode.Ok200) {
      toastNotification(toasterFlags.SUCCESS, data?.data?.message);
      yield put(setLocalUserResetPasswordSuccess(data));
    } else {
      const errorData = data?.response;
      yield put(setLocalUserResetPasswordError(errorData));
      if (errorData?.data?.message?.email) {
        toastNotification(toasterFlags.WARN, errorData?.data?.message?.email?.[0]);
      } else {
        toastNotification(toasterFlags.WARN, errorData?.data?.message);
      }
    }
  } catch (err) {
    toastNotification("error", "Something went wrong...!");
  }
}

export function* localUserWorkspaceLogin({ payload }) {
  try {
    //Api call to fetch token from idp
    const localUserTokenData = yield call(fetchLocalUserAccessToken, payload);

    if (localUserTokenData?.status === statusCode.Ok200 && localUserTokenData?.data?.accessToken) {
      let payload = {
        tenant_id: localStorageHelper.get("wsmLocalTenantId"),
        workspace_id: localStorageHelper.get("wsm_id"),
        token: localUserTokenData?.data?.accessToken,
      };
      //Api call to verify token and fetch user details
      const verifiedToken = yield call(getIdpAuthTokenApi, payload);

      if (verifiedToken?.status === statusCode.Ok200 && verifiedToken?.data) {
        let tokenData = {
          ...verifiedToken?.data?.success,
          accessToken: localUserTokenData?.data?.accessToken,
        };
        yield put(localWorkspaceLoginSuccess({ data: tokenData, status: verifiedToken?.status }));
      } else {
        storageCleanUpFunctionForWorkspace();
      }
    } else {
      if (localUserTokenData?.data) {
        // block for error handling from IDP token generation
        const errorData = localUserTokenData?.data;
        const errorMsg = getErrorMsg(errorData?.errorMessage);
        toastNotification("error", errorMsg);
        storageCleanUpFunctionForWorkspace();
      } else {
        // block for error handling from API token generation
        const errorData = localUserTokenData?.response?.data;
        toastNotification("error", errorData?.message);
        storageCleanUpFunctionForWorkspace();
      }
    }
  } catch (err) {
    toastNotification("error", "Something went wrong...!");
  }
}

//local user workspace login
export function* verifyWorkspaceOnLogin({ payload }) {
  try {
    //Api call to verify workspace to get issuer url
    const localUserTokenData = yield call(getInvitationApi, payload);

    if (localUserTokenData?.status === statusCode.Ok200 && localUserTokenData?.data) {
      yield put(setVerifiedWorkspaceUser({ data: localUserTokenData?.data?.success, status: localUserTokenData?.status }));
    } else {
      const errorData = localUserTokenData?.response?.data;
      toastNotification("error", errorData?.message);
      yield put(setInvalidWorkspaceUser({ data: localUserTokenData?.data?.result, status: localUserTokenData?.status }));
      let url = localStorageHelper.get("wsmTenantUrl");
      setTimeout(() => {
        localStorageHelper.clear();
        sessionStorage.clear();
        window.location.replace(url);
      }, 3000);
    }
  } catch (err) {
    toastNotification("error", "Something went wrong...!");
  }
}

export function* getIdpAuthToken({ payload }) {
  try {
    const idpTokenData = yield call(getIdpAuthTokenApi, payload);
    if (idpTokenData?.status === statusCode.Ok200) {
      if (idpTokenData?.data?.success) {
        setIdpTokenDataInLocalStorage(idpTokenData?.data?.success);
        yield put(setIdpToken({ data: idpTokenData?.data?.success, status: idpTokenData?.status }));
      }
    } else {
      const errorData = idpTokenData?.response?.data;
      toastNotification("error", errorData?.message);
      yield put(setIdpToken({ data: idpTokenData?.data, status: idpTokenData?.status }));
      storageCleanUpFunction();
    }
  } catch (err) {
    toastNotification("error", "Something went wrong...!");
  }
}

export function* verifyLocalUser({ payload }) {
  try {
    const userDetails = yield call(getLoginDeatails, payload);
    if (userDetails?.status === statusCode.Ok200) {
      yield put(veriFiedLocalUser({ data: userDetails?.data?.success, status: userDetails?.status }));
    } else {
      const errorData = userDetails?.response?.data;
      toastNotification("error", errorData?.message);
      yield put(invalidLocalUser({ data: userDetails?.data, status: userDetails?.status }));
      storageCleanUpFunction();
    }
  } catch (err) {
    toastNotification("error", "Something went wrong...!");
  }
}

export function* watchDummy() {
  yield takeLatest(loginActions.apiAction, getAllowedResource);
  yield takeLatest(loginActions.LOGOUT_USER, signOut);
  yield takeLatest(loginActions.GET_LOGIN_DETAILS_REQUEST, loginDetails);
  yield takeLatest(loginActions.LOGIN_ACTION, loginFunction);
  yield takeLatest(loginActions.GET_AUTH_TOKENS, authTokenFunction);
  yield takeLatest(loginActions.LOCAL_USER_SIGNUP, localUserSignupFunction);
  yield takeLatest(loginActions.LOCAL_USER_LOGIN, localUserLoginFunction);
  yield takeLatest(loginActions.LOCAL_USER_FORGOT_PASSWORD, localUserForgotPasswordFunction);
  yield takeLatest(loginActions.LOCAL_USER_RESET_PASSWORD, localUserResetPasswordFunction);
  yield takeLatest(loginActions.VERIFY_USER_ON_LOGIN, verifyWorkspaceOnLogin);
  yield takeLatest(loginActions.GET_IDP_TOKEN, getIdpAuthToken);
  yield takeLatest(loginActions.VERIFY_LOCAL_USER, verifyLocalUser);
  yield takeLatest(loginActions.WORKSPACE_LOCAL_USER_LOGIN, localUserWorkspaceLogin);
}

export default function* loginSaga() {
  yield all([watchDummy()]);
}
